import React from 'react';
import {SectionRef} from './Section';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {formattingDate} from '../../../utils/formatting';
import {getShumaType2and3Section1LoanTypeSentenceText} from '../../../utils/texts';
import styles from './styles.module.scss';

const Section1 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    pdfData: {
      usingLawyer,
      lawyerName,
      bankName,
      purchaseDate,
      purchase,
      propertyTypeName
    },
    pdfDataCustomers
  } = context.data;

  const customersNames = (pdfDataCustomers.length > 0)
    ? pdfDataCustomers.map(customer => customer.name).join(' ו - ')
    : '';
  const lawyerNameValue = (usingLawyer === 1)
    ? `באמצעות עו"ד ${lawyerName},`
    : '';
  const title = (
    <>
      <span>{context.sectionNumbers.section1}</span>
      <span>. מטרת השומה</span>
    </>
  )

  return (
    <SectionRef title={title} ref={ref}>
      <div className={styles.itemText}>
        <span>
          {[
          'נתבקשתי ע"י ה"ה',
          Boolean(lawyerNameValue)
            ? `${customersNames}, ${lawyerNameValue}`
            : customersNames,
          'להעריך את שווי שוק וערך למטרת ביטחון אשראי ל',
          `${bankName}.`,
          "בהתאם לתקן 19 בדבר פירוט מזערי נדרש בשומות מקרקעין המיועדות להצעת זכויות במקרקעין כבטוחה לאשראי. שווי שוק יוגדר בחוו\"ד זו כשווי הסביר העשוי להתקבל בעסקת מכר שבין מוכר מרצון לקונה מרצון, בתנאי שוק חופשי כאשר הנכס ריק פנוי וחופשי מכל חוב שיעבוד, עיקול, חזקה, ו/או זכויות צד ג' כלשהן. השומה הוזמנה לצורך מתן הלוואה. מטרת ההלוואה הנה מימון"
        ].filter(Boolean).join(' ')}
        </span>
        <span>
          <span> {propertyTypeName}</span>
          <span>{getShumaType2and3Section1LoanTypeSentenceText(context)}</span>
          {[
            Boolean(purchase) ? 'בהתאם להסכם רכישה' : '',
            Boolean(purchase) && Boolean(purchaseDate) ? ` מיום${formattingDate(purchaseDate)}` : '',
            Boolean(purchase) ? 'אשר הוצג בפני הח"מ' : '',
          ].filter(Boolean).join(' ')}.
        </span>
      </div>
    </SectionRef>
  );
});

export default Section1;
